import { useUserPhoneFromBrazeQuery } from 'generated/graphql-gateway';
import { useRoute } from 'hooks/navigation/use-route';

import { BRAZE_ID_PARAM } from './constants';

const usePhoneFromBrazeId = (): string => {
  const { params } = useRoute<{ [BRAZE_ID_PARAM]: string }>();
  const brazeId = params[BRAZE_ID_PARAM] ?? '';

  const { data } = useUserPhoneFromBrazeQuery({
    variables: {
      brazeId,
    },
    skip: !brazeId,
  });

  return data?.userPhoneFromBraze?.phone ?? '';
};

export default usePhoneFromBrazeId;
